<template>
  <div
    class=" 
        flex
        w-full
        bg-img
        vx-row
        justify-center 
      "
  >
    <transition name="zoom-fade" mode="out-in" appear>
      <div v-if="!selectForm" class="vx-col lg:w-2/3 w-full self-center">
        <div class="vx-row" style="justify-content:center;margin-top:-70px">
          <div class="vx-col w-full md:w-1/3 m-3 md:m-0">
            <vx-card
              class="text-center cursor-pointer"
              @click="setForm('staff')"
              style="border-radius: 2.5rem"
            >
              <img
                src="@/assets/images/login/personel.png"
                alt="graphic"
                class="mx-auto mb-4 hidden md:block login-bg"
              />
              <h3 class="mb-2">{{ $t("Login.PersonTitle") }}</h3>
              <span
                style="font-size:13px;"
                v-html="$t('Login.PersonDesc')"
              ></span>
            </vx-card>
          </div>
          <div class="vx-col w-full md:w-1/3 m-3 md:m-0">
            <vx-card
              class="text-center cursor-pointer mt-n97"
              @click="setForm('student')"
              style="border-radius: 2.5rem"
            >
              <img
                src="@/assets/images/login/ogrenci.png"
                alt="graphic"
                class="mx-auto mb-4 hidden md:block login-bg"
              />
              <h3 class="mb-2">{{ $t("Login.StudentTitle") }}</h3>
              <span
                style="font-size:13px;"
                v-html="$t('Login.StudentDesc')"
              ></span>
            </vx-card>
          </div>
          <!-- <div class="vx-col w-full md:w-1/3 m-3 md:m-0">
            <vx-card
              class="text-center cursor-pointer"
              @click="setForm('tumer')"
              style="border-radius: 2.5rem"
            >
              <img
                src="@/assets/images/login/tumer.png"
                alt="graphic"
                class="mx-auto mb-4 hidden md:block login-bg"
              />
              <h3 class="mb-2">{{ $t("Login.TumerTitle") }}</h3>
              <span v-html="$t('Login.TumerDesc')"></span>
            </vx-card>
          </div> -->
        </div>
      </div>

      <LoginPersonel v-if="selectForm == 'staff'"></LoginPersonel>
      <LoginStudent v-if="selectForm == 'student'"></LoginStudent>
      <LoginTumer v-if="selectForm == 'tumer'"></LoginTumer>
      <LoginGraduate v-if="selectForm == 'graduate'"></LoginGraduate>
    </transition>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Vue from "vue";
import AuthApi from "@/api/auth";
import LoginPersonel from "@/views/forms/login/LoginPersonel";
import LoginStudent from "@/views/forms/login/LoginStudent";
import LoginTumer from "@/views/forms/login/LoginTumer";
import LoginGraduate from "@/views/forms/login/LoginGraduate";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    LoginPersonel,
    LoginStudent,
    LoginTumer,
    LoginGraduate
  },
  data() {
    return {
      selectForm: "",
      localProfile: {},
      autoLogin: false,
      radios1: 1,
      KVKK: true,
      showUsernameForm: true,
      showTumerForm: false,
      navigationBtn: true,
      formDataLoginOther: {
        IdentityNumber: "",
        PhoneNumber: "",
        BirthDate: "",
        Gender: 0,
        Referer: "",
      },
      formDataLogin: {
        Username: "",
        Password: "",
        RememberMe: true,
        GoogleReCaptchaResponse: "",
        Referer: "",
        ReturnUrl: "",
        Tumer: false,
        Graduate: false
      },
      submitBusy: false,
    };
  },
  computed: {
    getLoginGroup() {
      return this.$store.getters["auth/getLoginGroup"];
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isAuthenticated() {
      this.localProfile;

      return this.$auth.isAuthenticated();
    },
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "tr") return { flag: "tr", lang: "Türkçe" };
      else if (locale == "en") return { flag: "en", lang: "English" };
      else if (locale == "ar") return { flag: "ar", lang: "عربي" };
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },
  },
  async created() {
    if (this.$route.query.logout) {
      this.$auth.logOut();
      return;
    }

    if (this.$route.query.form){
      if (this.$route.query.form == "student" || this.$route.query.form == "staff"){
        this.navigationBtn = false;
        this.setForm(this.$route.query.form);
      }
    }

    let loginGroup = this.$store.getters["auth/getLoginGroup"];
    if (loginGroup) this.setForm(loginGroup);
  },
  methods: {
    handleFormGroupEvent(formName) {
      this.setForm(formName);
    },
    setForm(formName) {
      this.selectForm = formName;
      this.$store.dispatch("auth/updateLoginGroup", formName);
    },
    async handleLoginEvent(payload) {
      this.localProfile = payload.profile;
    },
    logout() {
      this.$auth.logOut();
    },
    updateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      if (locale == "ar") this.$vs.rtl = true;
      else this.$vs.rtl = false;
    },
    loginWithGoogle() {
      window.location.assign(
        process.env.VUE_APP_BASE_URL +
          "api/auth/google?returnUrl=" +
          (this.$route.query.ReturnUrl
            ? process.env.VUE_APP_BASE_URL +
              "login?ReturnUrl=" +
              this.$route.query.ReturnUrl
            : process.env.VUE_APP_BASE_URL)
      );
    },
    loginWithTumer() {
      this.showUsernameForm = false;
      this.showTumerForm = true;
      this.formDataLogin.Tumer = true;
      this.formDataLogin.Username = "";
      this.formDataLogin.Password = "";
    },
    loginWithUsername() {
      this.showTumerForm = false;
      this.showUsernameForm = true;
      this.formDataLogin.Tumer = false;
      this.formDataLogin.Username = "";
      this.formDataLogin.Password = "";
    },
    async updateProfile() {
      const isValid = await this.$refs.profileForm.validate();
      if (this.submitBusy || !isValid) return;

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: "#profileSubmitButton",
        scale: 0.45,
      });
      try {
        var formPostData = this.formDataLoginOther;
        formPostData.Referer = this.$route.query.ReturnUrl;

        var response = await AuthApi.update(formPostData, this);

        if (!response.data.error && !response.data.errors) {
          var userData = this.userInfo;
          userData.NeedProcess = false;
          userData.IdentityNumber = formPostData.IdentityNumber;
          userData.PhoneNumber = formPostData.PhoneNumber;
          userData.BirthDate = formPostData.BirthDate;
          userData.Gender = formPostData.Gender;

          this.$auth.clearInfo(userData);

          if (this.$route.query.ReturnUrl) {
            var gateway = await AuthApi.gateway(response.data.GatewayUrl, this);

            if (!gateway.data.error && !gateway.data.errors) {
              window.location.assign(response.data.Referer);
            } else {
              setTimeout(() => {
                this.$vs.loading.close("#profileSubmitButton .con-vs-loading");
              }, 100);
            }
          } else {
            this.$router.push("/");
          }
        }
      } finally {
        this.submitBusy = false;
      }
    },
    async login() {
      const isValid = await this.$refs.loginform.validate();
      if (this.submitBusy || !isValid) return;

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: "#loginSubmitButton",
        scale: 0.45,
      });
      try {
        this.formDataLogin.Referer = this.$route.query.ReturnUrl;
        this.$recaptcha("login").then(async (token) => {
          this.formDataLogin.GoogleReCaptchaResponse = token;
          await this.$auth.login(this.formDataLogin, this);
        });
      } finally {
        this.submitBusy = false;
      }
    },
  },
};
</script>

<style lang="scss">
.vx-card {
  z-index: 1;
}
.login-bg {
  width: 100%;
}

.social-login {
  .bg-google {
    background-color: #3b75d5;
  }
  .bg-tumer {
    background: linear-gradient(60deg, #ef5350, #e53935);
  }
  .bg-user {
    background-color: #4285f4;
  }
  .bg-turkiye{
    background: #cf1a21; 
  }
}

.mt-80 {
  margin-top: -120px !important;
}

@media only screen and (max-width: 767px) {
  .mt-80 {
    margin-top: 0.75rem !important;
  }
}
</style>
